import { Row } from "antd";
import React, { useState, useEffect } from "react";
import SkillBubbleChart from "../SkillIndexCircle/SkillBubbleChart";
import SkillIndexCircle from "../SkillIndexCircle/SkillIndexCircle";

export default function SkillIndex({ data, dummy }) {

  const [gap, setGap] = useState([]);
  useEffect(() => {
    let temp = [];
    let gap = 0;
    data?.map((i) => {
      if (temp.length === 0 || temp.length % 3 == 0) {
        temp = [...temp, 25];
        gap = i.value / 3;
      } else {
        temp = [...temp, gap];
        gap = gap + i.value / 3.5;
      }
    });
    setGap(temp);
  }, []);

  const Skill_Index = () => {
    const skillIndex = data
    const skillIndexData = skillIndex?.sort((a, b) => b.value - a.value);
    const NoData = [
      { name: "No Data", value: "" },
      { name: "No Data", value: "" },
      { name: "No Data", value: "" },
    ];
    return (
      <>
        <div className="Skill_Index">
          {/* <h3 className="DResume-Tooltips" ><span>Skill index</span> <span><ToolTips placement="bottomLeft" title="Your skill index is a visual collection of the total skills you have in your work history. The graph of your skill index reflects the calculated value of each skill." /></span> </h3>  */}
          <div className="Skill_Index_Content">
            {/* <SkillIndex data={skillIndex} /> */}
            {skillIndexData?.length > 0  && data != undefined ?(
              <SkillBubbleChart data={skillIndexData} />
            ) : (
              <SkillBubbleChart data={NoData} />
            )}

            {/* <BubbleChart
              graph={{
                zoom: window.innerWidth > 768 ? 0.4 : 0.8,
                offsetX: window.innerWidth > 768 ? 0.3 : 0.05,
                offsetY: window.innerWidth > 768 ? 0.05 : 0.2,
              }}
              width={
                window.innerWidth > 768
                  ? window.innerWidth - 240 - 40
                  : window.innerWidth - 30
              }
              height={window.innerWidth > 768 ? 550 : 400}
              padding={-20} // optional value, number that set the padding between bubbles
              showLegend={false} // optional value, pass false to disable the legend.
              legendPercentage={20} // number that represent the % of with that legend going to use.
              legendFont={{
                family: "Arial",
                size: 12,
                color: "#000",
                weight: "bold",
              }}
              valueFont={{
                family: "Arial",
                size: 12,
                color: "#fff",
                weight: "bold",
              }}
              labelFont={{
                family: "Arial",
                size: 16,
                color: "#fff",
                weight: "bold",
              }}
              //Custom bubble/legend click functions such as searching using the label, redirecting to other page
              // bubbleClickFunc={this.bubbleClick}
              // legendClickFun={this.legendClick}
              data={data}
            /> */}
          </div>
        </div>
      </>
    );
  };
  return (
    <>
      {
        dummy && dummy.length>0?
          //  console.log("shehl",dummy) 
          <Row
            style={{
              position: "relative",
            }
            }
          >
            {
              dummy?.map((item, index) => {
                // console.log("skillIndex: ", item);
                if (item.value > 1000) {
                  return null
                }
                else
                  return (
                    <SkillIndexCircle
                      cSize={(item.value < 250 ? 100
                        : item.value - 150)}
                      cRadius={120}
                      name={item.name}
                      percent={item.value}
                      color={
                        "rgb(" +
                        Math.floor(Math.random() * 256) +
                        "," +
                        (100 + Math.floor(Math.random() * 256)) +
                        "," +
                        (50 + Math.floor(Math.random() * 256)) +
                        ")"
                      }
                      zindex={(index + 1) % 2 == 0 ? 9 : 8}
                      cGap={gap[index]}
                      top={(index + 1) % 2 == 0 ? 80 : 0}
                      key={index + 1}
                    />
                  );
              })
            }
          </Row>
          :
          <Skill_Index />
      }
    </>
  );
}
